/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RoomTypeDto } from './RoomTypeDto';
import {
    RoomTypeDtoFromJSON,
    RoomTypeDtoFromJSONTyped,
    RoomTypeDtoToJSON,
} from './RoomTypeDto';

/**
 * 
 * @export
 * @interface ApartmentTypeDto
 */
export interface ApartmentTypeDto {
    /**
     * 
     * @type {number}
     * @memberof ApartmentTypeDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApartmentTypeDto
     */
    name: string;
    /**
     * 
     * @type {Array<RoomTypeDto>}
     * @memberof ApartmentTypeDto
     */
    readonly roomTypes: Array<RoomTypeDto>;
}

/**
 * Check if a given object implements the ApartmentTypeDto interface.
 */
export function instanceOfApartmentTypeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "roomTypes" in value;

    return isInstance;
}

export function ApartmentTypeDtoFromJSON(json: any): ApartmentTypeDto {
    return ApartmentTypeDtoFromJSONTyped(json, false);
}

export function ApartmentTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApartmentTypeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'roomTypes': ((json['roomTypes'] as Array<any>).map(RoomTypeDtoFromJSON)),
    };
}

export function ApartmentTypeDtoToJSON(value?: ApartmentTypeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

